import { SvgIcon } from '@tribeplatform/react-ui-kit/Icon'
import { Tooltip } from '@tribeplatform/react-ui-kit/Tooltip'

interface Props {
  title?: string
  description?: string
  toolTipText?: string
  isLoading: boolean
}

export const ChartTitle = ({
  title,
  description,
  toolTipText,
  isLoading,
}: Props) => {
  return (
    <div className={isLoading ? 'opacity-30' : ''}>
      <div className="text-content text-lg">{title ?? ' '}</div>
      <div className="flex items-center space-s-1">
        <div className="text-xs text-content-subdued">{description ?? ' '}</div>
        {toolTipText && (
          <Tooltip key="privacy-admin">
            <Tooltip.Trigger>
              <SvgIcon className="w-4 h-4 cursor-pointer" name="info" />
            </Tooltip.Trigger>
            <Tooltip.Panel>{toolTipText}</Tooltip.Panel>
          </Tooltip>
        )}
      </div>
    </div>
  )
}
